import styled from "styled-components"
import { Link } from "gatsby"
import { device } from "breakpoints"
// import { FlexCol } from "../FlexGrid"
const navItemHorizontalSpacing = "32px"

export const NavBarContainer = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  margin: 0 auto;
  justify-content: space-between;
  padding: 21px 0;

  @media ${device.tablet} {
    padding: 26px 0;
  }
`

export const LogoWrapper = styled(Link)`
  display: flex;
  align-items: center;
  height: auto;

  > svg,
  > img {
    height: 18px;
    display: block;

    @media(min-width: 375px) {
      height: 24px;
    }

    @media ${device.tablet} {
      height: 36px;
      width: 212px;
    }
  }
`

export const NavWrapper = styled.div`
  display: flex;
`

export const Nav = styled.nav`

    left: 0;
    right: 0;
    width: 100%;
    opacity: 1;
    position: relative;
    bottom: auto;
    background: none;
    transform: none;
    justify-content: flex-end;
  }
`

export const NavList = styled.ul`
  display: flex;
  list-style: none;
  margin: 0;
  width: 100%;
  height: auto;
  align-items: center;
  justify-content: center;
  flex-direction: row;

`

export const NavListItem = styled.li`
  width: 100%;
  a {
    display: block;
    text-align: center;
    font-family: ${props => props.theme.secondaryFont};
    text-transform: uppercase;
    letter-spacing: 2px;
    padding: 10px 10px;
    font-weight: 500;
    font-size: 10px;
    text-decoration: uppercase;
    color: ${props => props.theme.textColor};


    @media(min-width: 375px) {
      font-size: 12px;
    }

    @media ${device.tablet} {
      font-size: 18px;
      padding: 10px ${navItemHorizontalSpacing};
    }
  }

  &:last-child a {
    padding-right: 0;

  }

  span {
    position: relative;
    ::before {
      content: "";
      position: absolute;
      left: 0;
      opacity: 0;
      height: 2px;
      width: 100%;
      bottom: -6px;
      transition: 200ms;
      background: ${props => props.theme.textColor};
    }
  }

  :hover {
    span::before {
      opacity: 1;
      bottom: -3px;
    }
  }
`

export const SocialLinksWrapper = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid red;
`

export const QuickSearchWrapper = styled(Link)`
  display: flex;
  align-items: center;
  padding: 0 ${navItemHorizontalSpacing};
  max-height: 60px;
  height: 100%;
  opacity: 1;
  transition: 110ms;

  :hover {
    opacity: 0.7;
  }
  svg {
    height: 20px;
  }
`

export const Clickable = styled.div`
  display: block;
  height: 100%;
  width: 100%;
  z-index: 4;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (min-width: 768px) {
    display: none;
  }
`
